import { useEffect, useState } from "react";
import logoimg from "../assets/images/logo.png";
import { Link, useLocation, useNavigate, NavLink } from "react-router-dom";

function Navbar({ scrolled }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <nav className={`si-nav ${scrolled ? "scrolled" : "top"}`}>
        <div className="si-nav-inner">
          {/* Logo */}
          <div className="si-nav-brand">
            <img
              src={logoimg}
              alt="SwiftIntelli Logo"
              className="si-logo"
              onClick={() => navigate("/")}
            />

            <span className="powered_text">
              Powered by{" "}
              <Link
                to="https://sysintelli.com"
                target="_blank"
                rel="noopener noreferrer"
                className="powered_link"
              >
                SysIntelli
              </Link>
            </span>
          </div>

          {/* Desktop Navigation */}
          <ul className="si-nav-links">
            {user?.role === "admin" ? (
              <>
                <li>
                  <Link to="/home-settings">Home Settings</Link>
                </li>

                <li>
                  <Link to="/manage-courses">Manage Courses</Link>
                </li>

                <li>
                  <Link to="/enrollments">Enrollments</Link>
                </li>

                <li>
                  <Link to="/admin-add-blog">Add Blog</Link>
                </li>

                <li>
                  <Link to="/admin-about">About</Link>
                </li>

                <li>
                  <Link to="/admin-whyus">Why Us</Link>
                </li>

                <li>
                  <Link to="/admin-who-we-serve">Who We Serve</Link>
                </li>

                <li>
                  <Link to="/admin-testimonials">Testimonials</Link>
                </li>

                <li>
                  <Link to="/admin-consultations">Consultations</Link>
                </li>

                <li>
                  <Link to="/admin-course-features">Course Features</Link>
                </li>

                <li>
                  <Link to="/admin-demo-sessions">Demo Sessions</Link>
                </li>

                <li>
                  <Link to="/login-users">Login Users</Link>
                </li>

                <li>
                  <button className="si-logout-btn" onClick={logout}>
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li>
                  <NavLink
                    to="/about-us"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    About
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/why-swiftintelli"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Why SWIFTIntelli
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/courses"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Courses
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/blogs"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    Blogs
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/contact-us"
                    className={({ isActive }) =>
                      `si-nav-cta ${isActive ? "active" : ""}`
                    }
                  >
                    Contact Us
                  </NavLink>
                </li>
              </>
            )}
          </ul>

          {/* Mobile Button */}
          <button
            className={`si-hamburger${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle navigation"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* ================= MOBILE MENU ================= */}
      <div className={`si-mobile-menu${menuOpen ? " open" : ""}`}>
        {user?.role === "admin" ? (
          <>
            <Link to="/home-settings" onClick={closeMenu}>
              Home Settings
            </Link>
            <Link to="/manage-courses" onClick={closeMenu}>
              Manage Courses
            </Link>
            <Link to="/enrollments" onClick={closeMenu}>
              Enrollments
            </Link>
            <Link to="/admin-add-blog" onClick={closeMenu}>
              Add Blog
            </Link>
            <Link to="/admin-about" onClick={closeMenu}>
              About
            </Link>
            <Link to="/admin-whyus" onClick={closeMenu}>
              Why Us
            </Link>
            <Link to="/admin-who-we-serve" onClick={closeMenu}>
              Who We Serve
            </Link>
            <Link to="/admin-testimonials" onClick={closeMenu}>
              Testimonials
            </Link>
            <Link to="/admin-consultations" onClick={closeMenu}>
              Consultations
            </Link>
            <Link to="/admin-course-features" onClick={closeMenu}>
              Course Features
            </Link>
            <Link to="/admin-demo-sessions" onClick={closeMenu}>
              Demo Sessions
            </Link>
            <Link to="/login-users" onClick={closeMenu}>
              Login Users
            </Link>
            <button
              className="si-mobile-logout"
              onClick={() => {
                logout();
                closeMenu();
              }}
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <NavLink
              to="/about-us"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              About
            </NavLink>

            <NavLink
              to="/why-swiftintelli"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Why SWIFTIntelli
            </NavLink>

            <NavLink
              to="/courses"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Courses
            </NavLink>

            <NavLink
              to="/blogs"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Blogs
            </NavLink>

            <NavLink
              to="/contact-us"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Contact Us
            </NavLink>
          </>
        )}
      </div>
    </>
  );
}

export default Navbar;
